// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
// import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels"; // Starter Custom Code
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
// import React, { useState } from "react"; // Starter Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { CartLineModel, OrderLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { HTMLAttributes } from "react";
/* Starter Custom Code - End */

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel | ProductModel; // Starter Custom Code
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductDescriptionStyles;
    // Starter Custom Code
    overridedStyles?: ProductDescriptionStyles;
}

type Props = OwnProps & HTMLAttributes<HTMLElement>; // Starter Custom Code

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
    // Starter Custom Code
    wrapper?: TypographyProps;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    wrapper: {
        forwardAs: "div",
    },
    productDetailLink: {
        css: css`
            /* Store Custom Code - Start */
            ${linkAltStyles()}
            width: calc(100%);
            /* Store Custom Code - End */
        `,
        /* Store Custom Code - Start */
        typographyProps: {
            css: css`
                display: inline-block;
                width: calc(100%);
                text-overflow: ellipsis;
                overflow: hidden;
            `,
        },
        /* Store Custom Code - End */
    },
};

const ProductDescription = ({
    product: baseProduct, // Starter Custom Code
    onClick,
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
}: Props) => {
    /* Starter Custom Code - Start */
    const styles = useExpandProps(productDescriptionStyles, extendedStyles, overridedStyles);
    const trackSelectItem = ga.use.trackSelectItem({ items: baseProduct });
    const product = "product" in baseProduct ? baseProduct.product : baseProduct;

    const description =
        ("productTitle" in product && product.productTitle) ||
        ("shortDescription" in product && product.shortDescription) ||
        ("description" in product && product.description) ||
        "";

    const productDetailPath =
        "productInfo" in baseProduct
            ? baseProduct.productInfo.productDetailPath
            : ("productUri" in product && product.productUri) || "";

    const isActive =
        "isActiveProduct" in product ? product.isActiveProduct : "isActive" in product ? product.isActive : true;

    const output =
        productDetailPath && isActive ? (
            <Link
                {...styles.productDetailLink}
                href={productDetailPath}
                data-test-selector="productDescriptionLink"
                onClick={(event: React.MouseEvent<Element, MouseEvent>) => {
                    onClick && onClick(event);
                    trackSelectItem();
                }}
            >
                {description}
            </Link>
        ) : (
            <Typography {...styles.productDetailDescription}>{description}</Typography>
        );

    return <Typography {...styles.wrapper}>{output}</Typography>;
    /* Starter Custom Code - End */
};

export default ProductDescription;
